export const localPaths = {
    home: '',
    explorer: '',
    reference: 'reference',
    library: 'library',
    glossary: 'glossary',
    help: 'help',
    about: 'about',
    termsAndConditions: 'about/terms-and-conditions',
    privacyPolicy: 'about/privacy-policy',
    eula: 'about/eula',
    communityGuidelines: 'about/community-guidelines',
    history: 'history',
    tutorial: 'tutorial',
    ocr: 'ocr',
    userFeedback: 'userFeedback',
    userfeedback: 'user-feedback',
    lessons: 'lessons', // redirect to lessons (legacy)
    landing: 'landing',
};
